<template>
  <Sidebar />
  <Content class="reports-content">
    <header class="creator-header">
      <h2>Reports</h2>
      <queue-progress :isStatic="true" />
    </header>
    <Loading class="static" v-if="is_loading" />
    <div class="data-wrap" v-else>
      <Scrollbar :class="['data-list']" :show_bar="true">
        <Table :style="'--top: 0px'">
          <template #head>
            <tr>
              <th class="name-row"><span>Report Name</span></th>
              <th><span>Description</span></th>
              <th class="date-row"><span>Date Range</span></th>
              <th class="svg-th"><span>Action</span></th>
            </tr>
          </template>

          <template #body>
            <!-- template pic -->
            <template v-if="data.length === 0">
              <tr>
                <td colspan="4">
                  <NoData />
                </td>
              </tr>
            </template>

            <tr
              v-else
              v-for="(row, index) in data"
              :key="index"
              v-show="
                row.show &&
                ( !row.is_only_internal ||
                  (row.is_only_internal && $store.state.user_data.is_motom_internal_user)
                ) &&
                // special case for Wild merchant
                ( row.id !== 88 ||
                  (row.id === 88 && $store.state.user_data.merchant_account.merchant_name_in_program === 'wild')
                ) &&
                // CJ-only reports
                ( !row.is_cj_only || (row.is_cj_only && projectName === 'cj') && row.canDownload)
              "
              :class="[row.is_loading && 'loading-row']"
            >
              <td class="name-row">
                <span>{{ row.name }}</span>
              </td>

              <td>
                <span>{{ row.desc }}</span>
              </td>

              <td class="date-row" >
                <DatePicker @update-date="updateDate" :spec_key="index" v-if="!row.no_date_picker"/>
              </td>

              <td>
                <span class="svg-td">
                  <el-button
                    size="small"
                    text
                    :disabled="!row.canDownload || row.is_loading"
                    @click="fileDownload(row)"
                  >
                  <svg-icon
                    :class="[!row.canDownload && 'not-allowed-svg']"
                    name="download"/>
                  </el-button>
                </span>
              </td>
            </tr>
          </template>
        </Table>
      </Scrollbar>
    </div>

    <el-dialog v-model="is_show_email_modal" title="Download Failed" width="400px">
      <p>The file is too large to download directly. We can send it to your email instead.</p>
      <template #footer>
        <el-button @click="is_show_email_modal = false">Cancel</el-button>
        <el-button type="primary" @click="emailDownload()">Send to email</el-button>
      </template>
    </el-dialog>
  </Content>


</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';
import Loading from '@/components/ui/Loading.vue';
import Button from '@/components/ui/Button.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Table from '@/components/ui/Table.vue';
import NoData from '@/components/creator/NoData.vue';
import DatePicker from '@/components/ui/DatePicker.vue';
import Modal from '@/components/ui/Modal.vue';
import { ElButton, ElDialog } from 'element-plus';
import moment from 'moment';
import { handleMaxMinFun } from '@/utils/SwitchFun';

export default {
  name: 'Reports',

  components: {
    Sidebar,
    Scrollbar,
    Loading,
    Content,
    Button,
    Table,
    NoData,
    DatePicker,
    Modal,
    ElButton,
    ElDialog
  },

  data() {
    return {
      is_loading: false,
      data: [
        {
          name: 'Creator Performance By Day',
          desc: 'Track daily sales and engagement metrics for each creator',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 1,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_loading: false,
        },
        {
          name: 'Product Performance',
          desc: 'Analyze engagement trends for products that creators share',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 2,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_loading: false,
        },
        {
          name: 'Links Performance',
          desc: '',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 3,
          show: false,
          canDownload: false,
          is_only_internal: false,
          is_loading: false,
        },
        {
          name: 'Collections Performance',
          desc: 'Measure sales and engagement across curated product collections',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 4,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_loading: false,
        },
        {
          name: 'Storefront Posts Performance',
          desc: 'Measure sales and engagement across posts shared in creator storefronts',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 5,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_loading: false,
        },
        {
          name: 'Creator Motom Activity',
          desc: `View sales information by storefront creators' Motom activity`,
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 6,
          show: false,
          canDownload: true,
          is_only_internal: false,
          is_loading: false,
        },
        {
          name: 'Links Data',
          desc: '',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 7,
          show: true,
          canDownload: true,
          is_only_internal: true,
          is_loading: false,
        },
        {
          name: 'Promotional Code Performance',
          desc: '',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 88,
          show: true,
          canDownload: true,
          is_only_internal: true,
          is_loading: false,
        },
        // CJ-only reports
        {
          name: 'Add 10+ products',
          desc: 'e.g., "Incomplete: 5 out of 10 active products added"',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 101,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
        },
        {
          name: 'Feature 3+ products',
          desc: 'e.g., "Incomplete: 2 out of 3 active products are featured"',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 102,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
        },
        {
          name: 'Create 3 Posts (Any Social)',
          desc: 'e.g., "Complete: 3 active posts on storefront"',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 103,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
        },
        {
          name: 'Tag at least one product per post (minimum of 3 products tagged across posts)',
          desc: 'e.g., "Incomplete: 2 out of 3 products tagged to one active post on storefront"',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 104,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
        },
        {
          name: 'Create a collection',
          desc: 'e.g., "Complete: 1 active collection on storefront"',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 105,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
        },
        {
          name: 'Add 4+ products to a collection',
          desc: 'e.g., "Complete: 4 products added to a collection"',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 106,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
        },
        {
          name: 'Copy Your Storefront Link to Share',
          desc: 'e.g., "Copied Storefront Link [x] amount times"',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 107,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
        },
        {
          name: 'Copy a Product Short Link to Share',
          desc: 'e.g., "Copied Product Shortlinks [x] amount times"',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 108,
          show: true,
          canDownload: false,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
        },
        {
          name: 'Creator Onboarding Status',
          desc: 'Creator Onboarding Status tracks onboarding task completion, timing, and overall progress',
          start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
          end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
          id: 109,
          show: true,
          canDownload: true,
          is_only_internal: false,
          is_cj_only: true,
          is_loading: false,
          no_date_picker: true,
        },
      ],
      start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
      end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
      is_show_email_modal: false,
      email_download_row: null,
    };
  },

  computed: {
    permission_reports() {
      return this.$store.state.user_data?.permission_list?.reports;
    },
    projectName() {
      return this.$store.state.projectName;
    },
    is_only_internal() {
      return this.$store.state.user_data.is_motom_internal_user;
    },
  },

  methods: {
    updateDate(obj) {
      this.data[obj.key].start_date = moment(obj.start_date).format('YYYY-MM-DD');
      this.data[obj.key].end_date = moment(obj.end_date).format('YYYY-MM-DD');
    },

    fileDownload(row) {
      if (!row.canDownload || row.is_loading) {
        return;
      }

      row.is_loading = true;

      let params_data = {
        start_date: row.start_date,
        end_date: row.end_date,
      };

      let api = '/creator/get-performance-by-creator-by-day-csv-file';
      switch (row.id) {
        case 1:
          api = '/creator/get-performance-by-creator-by-day-csv-file'; //done
          break;
        case 2:
          api = '/creator/get-product-performance-csv-file'; //done
          break;
        case 3:
          api = '/creator/get-performance-by-creator-by-day-csv-file';
          break;
        case 4:
          api = '/creator/get-collections-performance-csv-file'; //done
          break;
        case 5:
          api = '/creator/get-posts-performance-csv-file'; //done
          break;
        case 6:
          api = '/creator/get-motom-sales-by-creator-by-day-csv-file'; //done
          break;
        case 7:
          api = '/creator/get-shortlink-performance-csv-file';
          break;
        case 88:
          api = '/creator/get-wild-promotional-code-performance-csv-file';
          break;
        // CJ-only reports (API TBD)
        case 101:
          api = ''; // TODO: Add 10+ products API
          break;
        case 102:
          api = ''; // TODO: Feature 3+ products API
          break;
        case 103:
          api = ''; // TODO: Create 3 Posts API
          break;
        case 104:
          api = ''; // TODO: Tag products per post API
          break;
        case 105:
          api = ''; // TODO: Create a collection API
          break;
        case 106:
          api = ''; // TODO: Add 4+ products to collection API
          break;
        case 107:
          api = ''; // TODO: Copy Storefront Link API
          break;
        case 108:
          api = ''; // TODO: Copy Product Short Link API
          break;
        case 109:
          api = '/creator/get-creator-onboarding-status-csv-file'; //done
          break;
      }

      this.$ajax(api, {
        params: params_data,
        method: 'get',
      })
        .then((res) => {
          if (res.status == 200) {
            let name = res.headers['content-disposition'].split('filename=');
            name = name[1] ? name[1] : 'report';
            this.$JsDownload(res.data, `${name}.csv`);
            this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download Success!`);
          } 
          else if (row.id===4 && res.status == 202){
            this.email_download_row = row;
            this.is_show_email_modal = true;
          }
          else {
            this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download False!`);
          }
          row.is_loading = false;
        })
        .catch((err) => {
          row.is_loading = false;
          if (row.id===4 && (err?.response?.status === 202 || err?.response?.status === 504)) {
            this.email_download_row = row;
            this.is_show_email_modal = true;
          } else {
            this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download Failed!`);
          }
        });
    },

    emailDownload() {
      const row = this.email_download_row;
      if (!row) return;
      this.is_show_email_modal = false;
      row.is_loading = true;
      this.$ajax('/creator/request-collections-performance-csv-email', {
        params: { start_date: row.start_date, end_date: row.end_date },
        method: 'post',
      })
        .then(() => {
          row.is_loading = false;
          this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Report will be sent to your email!`);
        })
        .catch(() => {
          row.is_loading = false;
          this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Request Failed!`);
        });
    },

    startFunction() {
      if (this.$store.state.user_data.merchant_account_id) {
        if (!this.permission_reports?.downloadReports?.permission) {
          this.$router.push({ name: 'creator--list' });
        }
        this.data.forEach((e) => {
          let checkTime = handleMaxMinFun(e.start_date, e.end_date, this);
          e.start_date = checkTime[0];
          e.end_date = checkTime[1];

          if (this.$store.state.user_data.merchant_account.merchant_name_in_program == 'macys' && e.id == 6) {
            e.show = true;
          }
        });

        if (this.permission_reports.downloadCreatorPerformanceByDay.permission) {
          this.data[0].canDownload = true;
        }

        if (this.permission_reports.downloadPerformanceOverview.permission) {
        }

        if (this.permission_reports.downloadProductPerformance.permission) {
          this.data[1].canDownload = true;
        }

        if (this.permission_reports.downloadCollectionsPerformance.permission) {
          this.data[3].canDownload = true;
        }

        if (this.permission_reports.downloadPostPerformance.permission) {
          this.data[4].canDownload = true;
        }

        if (this.permission_reports.downloadBrandContentPerformance.permission) {
        }
      }
    },
  },
  mounted() {
    this.startFunction();
  },
};
</script>

<style lang="scss">
.reports-content {
  padding: 24px 48px;

  header {
    display: flex;
    align-items: center;

    h2 {
      font: var(--font-demi-36);
      color: var(--Black-100);
    }
  }

  .data-wrap {
    margin: 16px 0;
    border-top: 1px solid var(--black-20);
    height: calc(95% - 16px);

    .btn {
      border: solid 1px var(--border);
      font-size: 12px;
      padding: 6px 8px;
      border-radius: 6px;
      text-align: center;
    }

    .svg-th {
      width: 100px;
    }

    .svg-td {
      display: flex;
      gap: 12px;
      align-items: center;
      justify-content: flex-start;

      .svg-icon {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }

    .date-row {
      width: 350px;
    }

    .name-row {
      width: 300px;
    }

    .not-allowed-svg {
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.5;
    }

    .loading-row {
      opacity: 0.3;
      pointer-events: none;
    }
  }
}
</style>
